/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import api from 'api';

import ExpiredToken from './ExpiredToken';
import SetPassword from './SetPassword';
import ResetPassword from './ResetPassword';
import ChangeEmail from './ChangeEmail';

import userSelectors from 'redux/reduxStore/user';
import sessionSelectors from 'redux/reduxStore/session';
import sessionActions from 'redux/actions/session';
import userActions from 'redux/actions/user';

import routeNames from 'lib/routeNames';
import { authToken } from 'lib/storagePolyfill';
import AppUtils from 'lib/AppUtils';
import AccessTokenModel, { accessTokenTypes } from 'models/AccessTokenModel';

function mapStateToProps(state, routerProps) {

  return {
    user: userSelectors.getLoggedInUser(state),
    requiresMfa: sessionSelectors.requiresMfa(),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateUser: (user) => {
      return dispatch(userActions.receive(user));
    },
    logout: () => {
      return dispatch(sessionActions.logout());
    },
  }
}

function getTokenMessage(tokenType) {
  switch (tokenType) {
    case accessTokenTypes.FORGOT_PASSWORD:
      return {
        message: 'tokenExpiry.resetPwd.expiry.message.text',
        resolutionMessage: 'tokenExpiry.resetPwd.resolution.button.label',
        resolveActionUrl: routeNames.forgotPassword(),
      };
    case accessTokenTypes.CHANGE_EMAIL:
      return {
        message: 'tokenExpiry.changeEmail.expiry.message.text',
        resolutionMessage: 'tokenExpiry.changeEmail.resolution.button.label',
        resolveActionUrl: routeNames.home(),
      };
    default:
      return {
        message: 'tokenExpiry.newUser.expiry.message.text',
        resolutionMessage: 'tokenExpiry.newUser.resolution.button.label',
        resolveActionUrl: routeNames.loginEmail(),
      };
  }
}

class Token extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tokenType: '',
      token: '',
      isMfaEnabled: false,
      isExpired: false,
    };
  }

  UNSAFE_componentWillMount() {
    const token = authToken.get();
    const queryParams = AppUtils.getQueryParams(this.props.location.search);

    if (!token) {
      this.setState({
        tokenType: queryParams.type || '',
        isExpired: true,
      });
    } else {
      const session = authToken.decode();
      const userData = session.user;

      this.setState({
        tokenType: session.type,
        userId: userData.id,
        token,
        isMfaEnabled: userData.mfa_enabled === 1,
      });
    }
  }

  render() {
    const { tokenType, isExpired } = this.state;

    if (isExpired) {
      return <ExpiredToken {...getTokenMessage(this.state.tokenType)} />
    } else if (!tokenType || !this.props.user.id) {
      return null;
    }

    switch(tokenType) {
      case accessTokenTypes.FORGOT_PASSWORD:
        return <ResetPassword token={this.state.token} />;
      case accessTokenTypes.CHANGE_EMAIL:
        return <ChangeEmail token={this.state.token} />;
      default:
        return <div>missing token</div>;
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Token);
